import { useTranslation } from 'react-i18next';
import { getReversedLangDefinition, makeUrlWithLang } from '@/utils/helpers';

export function useChangeLang() {
  const { i18n } = useTranslation();

  const createNewLocation = () => {
    const { pathname, host, protocol } = window.location;
    return makeUrlWithLang({
      protocol: protocol.slice(0, -1),
      host,
      path: pathname,
      lang: getReversedLangDefinition(i18n.language).short,
    });
  };

  function changeLang() {
    const newLocation = createNewLocation();
    const searchParams = new URLSearchParams(window.location.search);
    const newUrl = new URL(newLocation);

    newUrl.search = searchParams.toString();

    window.location.replace(newUrl.toString());
  }

  return changeLang;
}
